import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticStyle: { position: "fixed", top: "0", left: "0", "z-index": "2" },
        attrs: { src: require("../../assets/Inca_logo_PNG.png"), width: "350" },
      }),
      _c("img", {
        staticStyle: {
          position: "absolute",
          "z-index": "1",
          top: "0",
          right: "0",
          height: "100%",
          opacity: "0.5",
        },
        attrs: {
          src: require("../../assets/Nuevo_Inca_fondo_opacidad.png"),
          alt: "",
        },
      }),
      _c("div", { staticClass: "top-login" }),
      _c("div", { staticClass: "bottom-login" }),
      _c(
        VCard,
        {
          staticClass: "text-center pa-1",
          staticStyle: { "z-index": "3", "border-radius": "40px !important" },
          attrs: { elevation: "10" },
        },
        [
          _c(
            VCardText,
            { staticStyle: { padding: "50px" } },
            [
              _c(
                VForm,
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function ($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid",
                  },
                },
                [
                  _c("div", [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons mb-8 mr-0",
                        staticStyle: { "font-size": "200px" },
                      },
                      [_vm._v("account_circle")]
                    ),
                  ]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        "La opción de inicio de sesión puede variar según tu empresa."
                      ),
                    ]),
                  ]),
                  _vm.current_provider === "email"
                    ? _c(
                        "div",
                        [
                          _c(VRow, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    name: "email",
                                    label: "Correo",
                                    id: "email",
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.email,
                                    callback: function ($$v) {
                                      _vm.email = $$v
                                    },
                                    expression: "email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    name: "password",
                                    label: "Contraseña",
                                    id: "password",
                                    type: "password",
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.password,
                                    callback: function ($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            VBtn,
                            {
                              staticClass: "mt-5 mb-5",
                              staticStyle: {
                                "border-radius": "20px !important",
                              },
                              attrs: {
                                color: "primary",
                                block: "",
                                "x-large": "",
                              },
                              on: { click: _vm.onLogin },
                            },
                            [_vm._v("Ingresar")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _c(VRow, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(VSelect, {
                              attrs: {
                                items: _vm.companies,
                                "item-text": "text",
                                "item-value": "id",
                                label: "Compañia",
                                small: "",
                                dense: "",
                                outlined: "",
                              },
                              model: {
                                value: _vm.current_company,
                                callback: function ($$v) {
                                  _vm.current_company = $$v
                                },
                                expression: "current_company",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.providers, function (provider) {
                    return (_vm.current_company == "otros" &&
                      provider.id == "google") ||
                      _vm.current_company != "otros"
                      ? _c(
                          VBtn,
                          {
                            key: provider.id,
                            staticClass: "mb-2",
                            staticStyle: { "border-radius": "20px !important" },
                            attrs: {
                              loading: provider.isLoading,
                              disabled: _vm.isSignInDisabled,
                              color: "primary",
                              block: "",
                              "x-large": "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onLoginSelect(provider)
                              },
                            },
                          },
                          [
                            _c(VIcon, { attrs: { small: "", left: "" } }, [
                              _vm._v("mdi-" + _vm._s(provider.id)),
                            ]),
                            _vm._v(" " + _vm._s(provider.label) + " "),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }